export default __webpack_public_path__ + "static/media/Stop.827b2f22.svg";